export default __webpack_public_path__ + "static/media/culture-icon2.f493d8f7.svg";